import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "editButton", "saveButton"]

  connect() {
    this.disable()
  }

  enable() {
    this.inputTarget.removeAttribute("disabled")
    this.inputTarget.focus()
    this.editButtonTarget.classList.add("hidden")
    this.saveButtonTarget.classList.remove("hidden")
  }

  disable() {
    this.inputTarget.setAttribute("disabled", "disabled")
    this.editButtonTarget.classList.remove("hidden")
    this.saveButtonTarget.classList.add("hidden")
  }

  submit() {
    // ensure value is submitted even if previously disabled
    this.inputTarget.removeAttribute("disabled")
    setTimeout(() => this.disable(), 0)
  }
}
